/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { Navigate } from "react-router-dom";
import { setAuth } from "../actions";
import Spinner from 'react-bootstrap/Spinner';
import secureLocalStorage from "react-secure-storage";
// import {} from '@azure/msal-browser';

const Logout = ({ }) => {
    const dispatch = useDispatch();

    useEffect(() => {
        secureLocalStorage.setItem("eKioskFoodUsages", '');
        dispatch(setAuth(null));
    }, [])

    return (<><Navigate to="/login" replace /></>)

    return (
        <>
            <div className="auth-container"
                style={{
                    backgroundImage: `url(${'/assets/images/auth.jpg'})`,
                    backgroundRepeat: 'no-repeat',
                    backgroundSize: 'cover',
                    backgroundPosition: 'top',
                    textAlign: 'center'
                }}>

                <Spinner animation="border"
                    variant="secondary"
                    style={{ marginTop: '40vh' }}
                    size="xl" />
            </div>

            {/*  */}
        </>
    );
}
export default Logout;